export const fall = {
  id: 'fall',
  state: 'fall',
  system: true,

  enter(ctx) {
    ctx.movement.stopWalk();
  },

  update(ctx) {
    if (ctx.movement.isGrounded()) {
      ctx.transition('idle');
    }
  },

  exit() {},
};
